export default __webpack_public_path__ + "static/media/react.3bf6fb4b.png";